import { ConfirmationDialog } from 'components';
import { useTranslation } from 'libs/i18n';
import { DialogProps } from 'libs/ui';

interface Props extends Pick<DialogProps, 'isOpen' | 'onClose'> {
  loading?: boolean;
  onConfirm: () => void;
}

export const DialogConfirmLinkToBright = ({
  loading,
  isOpen,
  onConfirm,
  onClose,
}: Props) => {
  const { t } = useTranslation();

  return (
    <ConfirmationDialog
      fullWidth
      headerCentered
      confirmButtonLabel={t('client.dialogConfirmLinkToBright.confirm')}
      isOpen={isOpen}
      loading={loading}
      maxWidth="sm"
      subtitle={t('client.dialogConfirmLinkToBright.subtitle')}
      title={t('client.dialogConfirmLinkToBright.title')}
      onBack={onClose}
      onClose={onClose}
      onConfirm={onConfirm}
    />
  );
};
